import React from "react";
import { C } from "./reportingStyles";
import { Badge } from "./ReportingShared";

const initials = (name) =>
  (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0].toUpperCase())
    .join("") || "?";

// Ranked top spenders for the Customer & Loyalty report. The API already returns them
// sorted and in scope; each row opens the customer's profile.
const TopSpendersList = ({ spenders = [], onSelect }) => {
  if (!spenders.length) {
    return (
      <div style={{ color: C.textLight, padding: 16, textAlign: "center", height: 220, display: "flex", alignItems: "center", justifyContent: "center" }}>
        No spend in the selected scope.
      </div>
    );
  }
  const max = spenders[0].totalSpent || 1;

  return (
    <div style={{ height: 260, overflowY: "auto", paddingRight: 4 }}>
      {spenders.map((c, i) => (
        <div
          key={c.id}
          className="rpt-row"
          role="button"
          tabIndex={0}
          title="Open customer profile"
          onClick={() => onSelect(c.id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onSelect(c.id);
            }
          }}
          style={{ display: "grid", gridTemplateColumns: "22px 34px minmax(0,1fr) auto", alignItems: "center", gap: 10, padding: "8px 6px", borderRadius: 8, cursor: "pointer" }}
        >
          <div style={{ fontSize: 12, fontWeight: 800, textAlign: "center", color: i < 3 ? C.coral : C.textLight }}>{i + 1}</div>
          <div style={{ width: 34, height: 34, borderRadius: "50%", background: C.coralLight, color: C.coral, fontWeight: 800, fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {initials(c.name)}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
              <span style={{ fontWeight: 700, fontSize: 13, color: C.text, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.name}</span>
              {c.active === false && <Badge color={C.coral} bg={C.coralLight}>Inactive</Badge>}
            </div>
            <div style={{ fontSize: 11, color: C.textLight, marginTop: 1 }}>
              {c.phone || "—"} · {c.totalOrders} {c.totalOrders === 1 ? "order" : "orders"}
            </div>
            <div style={{ height: 4, borderRadius: 2, background: C.borderLight, marginTop: 5 }}>
              <div style={{ width: `${Math.max(2, (c.totalSpent / max) * 100)}%`, height: "100%", borderRadius: 2, background: `linear-gradient(90deg, ${C.coral}, #00bfa5)` }} />
            </div>
          </div>
          <div style={{ fontWeight: 800, fontSize: 13, color: C.text, whiteSpace: "nowrap" }}>{c.totalSpent.toLocaleString()} SAR</div>
        </div>
      ))}
    </div>
  );
};

export default TopSpendersList;
